import React from 'react'
import PropTypes from 'prop-types'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import { ListItem } from 'pui-react-lists'
import EmailIcon from '../assets/EmailIcon'
import TextIcon from '../assets/TextIcon'
import { formatTime } from './utils'
import styles from './styles/ConversationsListItem'

// prefix styles for tops:
const prepareStyles = getMuiTheme().prepareStyles

const selectedConversationItem = prepareStyles(styles.selectedConversationItem)
const conversationItem = prepareStyles(styles.conversationItem)
const nameStyle = prepareStyles(styles.names)
const dateStyle = prepareStyles(styles.datetime)
const iconStyle = prepareStyles(styles.icon)

const IconForConvo = ({ isSelected, isActive, isEmail, isSeen }) => {
  let fill = 'grey'
  if (isSelected) fill = 'white'
  if (isActive && !isSeen) fill = 'black'
  const iconProps = { fill, styles: iconStyle }

  return isEmail ? <EmailIcon {...iconProps} /> : <TextIcon {...iconProps} />
}

IconForConvo.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  isEmail: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  isSeen: PropTypes.bool.isRequired,
}

const ConversationsListItem = ({
  data: {
    id: convoId,
    patients,
    patient_phone: patientPhone,
    last_message: lastMessageSentAt,
    active,
    seen,
    messages_type: messagesType,
  },
  handleConvoClick,
  isSelected,
  formatPhoneNumber,
}) => {
  const formattedTime = formatTime(lastMessageSentAt)

  const lineText =
    patients && !!patients.length
      ? patients.map(p => `${p.first_name} ${p.last_name}`).join(', ')
      : formatPhoneNumber(patientPhone)

  let itemStyle = isSelected ? selectedConversationItem : conversationItem
  if (active && !seen) {
    itemStyle = { ...itemStyle, fontWeight: 'bold' }
  }

  return (
    <ListItem
      style={itemStyle}
      className="ConversationItem"
      onClick={() => handleConvoClick(convoId)}
    >
      <span style={nameStyle}>{lineText}</span>
      <span style={dateStyle}>{formattedTime}</span>
      <IconForConvo
        isSelected={isSelected}
        isEmail={messagesType === 'email'}
        isActive={!!active}
        isSeen={!!seen}
      />
    </ListItem>
  )
}

ConversationsListItem.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  handleConvoClick: PropTypes.func.isRequired,
  formatPhoneNumber: PropTypes.func.isRequired,
}

export default ConversationsListItem



// WEBPACK FOOTER //
// ./src/components/Messages/ConversationsListItem.js